<template>
  <div
    v-if="item.transmissionType || item.fuel || emissions || consumption"
    class="mb-40">
    <div class="h4 extrabold mb-16">{{ dictionary.techTitle }}</div>

    <div class="row gx-5 gy-4">
      <div v-if="item.fuel" class="col-lg-3">
        <div class="b-tech align-items-center">
          <div v-if="isElectric" class="b-tech__leaf">
            <img src="/imgs/icons/leaf@2x.png" alt="Leaf" />
          </div>
          <div>
            <LazyImage :image="{ url: '/imgs/icons/fuel.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techFuelLabel }}</span>
            <span class="h6 extrabold c-primary-blue">{{ item.fuel }}</span>
          </div>
        </div>
      </div>
      <div v-if="item.transmissionType" class="col-lg-3">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/transmission.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techTransmissionLabel }}</span>
            <span class="h6 extrabold c-primary-blue">
              {{ item.transmissionType }}
            </span>
          </div>
        </div>
      </div>
      <template v-if="isElectric">
        <div v-if="item.drivingRange" class="col-lg-3">
          <div class="b-tech align-items-center">
            <div>
              <LazyImage :image="{ url: '/imgs/icons/power-range.png' }" />
            </div>
            <div>
              <span>{{ dictionary.techDrivingRangeLabel }}</span>
              <span class="h6 extrabold c-primary-blue">
                {{ dictionary.techDrivingRangeUnitPrefix }}
                {{ item.drivingRange.toLocaleString(lang) }}
                {{ dictionary.techDrivingRangeUnitSuffix }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="consumption" class="col-lg-3">
          <div class="b-tech align-items-center">
            <div>
              <LazyImage :image="{ url: '/imgs/icons/consumption.svg' }" />
            </div>
            <div>
              <span>{{ dictionary.techConsumptionLabel }}</span>
              <span class="h6 extrabold c-primary-blue">
                {{ item.consumption }} lt/100Km
              </span>
            </div>
          </div>
        </div>
      </template>

      <div v-if="emissions" class="col-lg-3">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/emmission.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techEmmissionsLabel }}</span>
            <span class="h6 extrabold c-primary-blue">
              {{ item.emissions }} gr/Km
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../../lib/lib'
import LazyImage from './../common/LazyImage.vue'
import constants from './../../../lib/constants'

export default {
  components: { LazyImage },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      lang: false,
    }
  },
  computed: {
    isElectric() {
      return this.item.fuelPreValue === constants.flexdrive.fuelType.electic
    },

    emissions() {
      if (!this.item.emissions || parseInt(this.item.emissions) <= 0) {
        return false
      }
      return true
    },
    consumption() {
      if (!this.item.consumption || parseInt(this.item.consumption) <= 0) {
        return false
      }
      return true
    },
    transmissionLabel() {
      let res
      const transmission = this.item.transmissionTypePreValue
      const { manual, auto } = constants.flexdrive.filters.transmissionsOptions

      switch (transmission) {
        case manual:
          res = this.dictionary.transmissionManual
          break
        case auto:
          res = this.dictionary.transmissionAutomatic
          break
        default:
          res = null
      }
      return res
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()
  },
}
</script>
